import { Flag } from '@advanza/ui'
import { ReplacementLeadStats } from 'interfaces/ReplacementLeads'
import ReclaimStatusBar from './ReclaimStatusBar'

interface Props {
    stats: ReplacementLeadStats
    /** Per-account providers pool their entitlements, so owed cannot be split per subscription. */
    showOwedPerSubscription: boolean
}

const ReplacementLeadsAllTime = ({ stats, showOwedPerSubscription }: Props) => (
    <div className="flex flex-col gap-3">
        <div>
            <div className="flex items-center py-2 text-typography-text-xs font-bold text-grey-700 uppercase">
                <span className="flex-1">Filter</span>
                <span className="w-20 text-center">Received</span>
                {showOwedPerSubscription && <span className="w-16 text-center">Owed</span>}
                <span className="w-32 text-center">Accepted reclaims</span>
            </div>
            {stats.subscriptions.map((subscription) => (
                <div
                    key={subscription.subscriptionId}
                    className="flex items-center py-2.5 border-t border-grey-200">
                    <div className="flex-1 flex items-center gap-2">
                        <Flag countryCode={subscription.countryCode} />
                        <span className="font-bold text-dark">{subscription.serviceName}</span>
                    </div>
                    <span className="w-20 text-center font-bold text-dark">
                        {subscription.received}
                    </span>
                    {showOwedPerSubscription && (
                        <span className="w-16 text-center">
                            <span className="inline-block text-typography-text-sm font-bold text-goldenrod bg-gold/20 rounded-full px-2 py-0.5">
                                {subscription.owed}
                            </span>
                        </span>
                    )}
                    <span className="w-32 text-center text-bodyDark">
                        {subscription.acceptedReclaims}
                    </span>
                </div>
            ))}
            <div className="flex items-center justify-between pt-2.5 border-t border-grey-200">
                <span className="text-grey-800">
                    {stats.firstLeadDate ? `Since ${stats.firstLeadDate}` : 'No leads received yet'}
                </span>
                <span className="text-bodyDark">
                    <b className="text-dark">{stats.totals.received}</b> received ·{' '}
                    <b className="text-goldenrod">{stats.totals.owed}</b> owed ·{' '}
                    <b className="text-dark">{stats.totals.acceptedReclaims}</b> accepted reclaims
                </span>
            </div>
            <div className="pt-2 text-typography-text-sm text-grey-700">
                Owed = accepted reclaims that haven&#39;t received their replacement lead yet.
                Received includes the replacement leads themselves.
            </div>
        </div>
        <ReclaimStatusBar title="Reclaims — all time" counts={stats.reclaims.allTime} />
    </div>
)

export default ReplacementLeadsAllTime
